import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import { Button, IconButton } from '@mui/material';
import Swal from "sweetalert2";
import axios from 'axios';
import { baseURL } from '../../axiosInstance';


function DisturbutorLinkForm() {
  const { disturbid, typeid } = useParams()
  const [formData, setFormData] = useState({
    parent_id: disturbid,
    type: typeid,

    name: '',
    password: '',
    email: '',
    email2: '',
    phone: '',
    phone2: '',
    address: '',
    bank_details: '',
    other_details: '',
  });

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === 'radio' ? Number(value) : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const cleanedFormData = Object.keys(formData).reduce((acc, key) => {
      if (formData[key] !== "" && formData[key] !== null && formData[key] !== undefined) {
        acc[key] = formData[key];
      }
      return acc;
    }, {});

    try {
      {
        // Add new client
        console.log("create link", formData)
        const response = await axios.post(`${baseURL}/register`, cleanedFormData);
        if (response.status === 200) {
          // alert('Client added successfully!');
          Swal.fire('Success!', `${response?.data?.messeage}`, 'success');

        }
      }

      // Reset form
      setFormData({
        password: '',
        email: '',
        email2: '',
        phone: '',
        phone2: '',
        address: '',
        bank_details: '',
        other_details: '',


      });
    } catch (error) {
      console.log(`Error: ${error?.response}`);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.errors || "Something went wrong!",
      });
      console.error(error);
    }
  };


  return (
    <div className='distributerbgimage rounded-3 shadow d-flex justify-content-center align-items-center vh-100 p-4'>
      <div className='p-4 shadow rounded-5 d-flex flex-column' style={{ width: "900px", maxHeight: "500px", overflow: "auto" }} >
        <div className='flex-grow-1 '>
          <form onSubmit={handleSubmit}>
            <div className='row' >
              {[
                { label: 'Name', name: 'name', type: 'text', required: true },
                { label: "Password", name: 'password', type: "password" },
                { label: "Email", name: "email", type: "email", required: true }







                // {label:"0rganisation", name:"organisation", type:"text", required:true},
                // { label: 'Email', name: 'email', type: 'email',required:true  },
                // { label: 'Phone Number', name: 'phone', type: 'text',required:true},
              ].map((field) => (
                <div key={field.name} className='col-md-6 col-12'>
                  <label htmlFor={field.name} className='form-label distributerfont'>{field.label}</label>
                  <input
                    className='form-control'
                    name={field.name}
                    type={field.type}
                    placeholder={field.label}
                    value={formData[field.name]}
                    onChange={handleChange}
                    required={field.required}
                  />
                </div>
              ))}
              {[
                // { label: 'Name', name: 'name', type: 'text', required: true },
                // {label:"Username", name:'username', type:"text", required:true},
                // {label:"Lastname", name:'lastname', type:"text", required:true},
                // {label:"Lastname", name:'lastname', type:"text", required:true},


                { label: 'Email1', name: 'email1', type: 'email' },
                { label: 'Phone Number', name: 'phone', type: 'tel' },
                { label: 'Address', name: "addressa", type: "text" }
              ].map((field) => (
                <div key={field.name} className='col-md-6 col-12'>
                  <label htmlFor={field.name} className='form-label distributerfont'>{field.label}</label>
                  <input
                    className='form-control'
                    name={field.name}
                    type={field.type}
                    placeholder={field.label}
                    value={formData[field.name]}
                    onChange={handleChange}
                    required={field.required}
                  />
                </div>
              ))}


              <div className='d-flex justify-content-center align-items-center py-2 mt-0' >
                <Button variant="outlined" color="secondary" >Cancel</Button>
                <Button type='submit' variant="contained" color="primary" className='m-1' >
                  Submit
                </Button>
              </div>
            </div>

          </form>

        </div>
      </div>

    </div>
  )
}

export default DisturbutorLinkForm